import { useEffect, useRef, useState } from 'react';

import { Card } from 'primereact/card';
import { Dropdown } from 'primereact/dropdown';
import { Toast } from 'primereact/toast';

import { isInteger } from 'formik';

import { useParams } from 'react-router'

import Loading from '../components/Loading';
import Menu from '../components/Menu';
import TabelaParadas from '../components/Tabelas/TabelaParadas';

import api from '../services/api';

export default function Eficiencia(props) {
    const [data, setData] = useState([]);
    const [turmas, setTurmas] = useState([]);
    const [turma, setTurma] = useState();
    const [loading, setLoading] = useState(true);

    let params = useParams();
    const toast = useRef(null);

    const fetchData = () => {
        if (isInteger(params.importId)) {
            api.get(`dados/producao/${params.importId}`).then((response) => {
                setData(response.data.data)
                setTurmas(response.data.turmas);

                setLoading(false);

                toast.current.show({
                    summary: 'Observação',
                    severity: 'info',
                    detail: 'Selecione uma das turmas para visualizar seus dados'
                });
            }).catch((error) => {
                setLoading(false);
                toast.current.show({
                    severity: 'error',
                    summary: 'Erro Interno',
                    detail: error.response.data.message
                });
            });
        }
    }

    const returnTable = () => {
        let copy = [...data];
        let object = copy.find(element => {
            return element.turma_id === turma;
        });

        if (object) {
            return (
                <TabelaParadas data={object} name="values" />
            )
        }
    }

    useEffect(() => {
        fetchData();
    }, []);

    if (loading) {
        return (
            <Loading />
        )
    }

    return (
        <div>
            <Menu />
            <Toast ref={toast} />
            <Card className='p-m-3' style={{ maxWidth: '100vw' }}>
                <Dropdown
                    className='p-ml-2'
                    onChange={e => setTurma(e.value)}
                    options={turmas}
                    optionLabel='nome'
                    optionValue='id'
                    value={turma}
                />
                {returnTable()}
            </Card>
        </div>
    )
}